import { Form, Formik } from "formik";
import React, { useState } from "react";
import styled from "styled-components";

import API from "../api/api";
import plusGenerator from "../assets/plusGenerator.svg";
import XIcon from "../assets/x.svg";
import AddSpacing from "../components/AddSpacing";
import Icon from "../components/Icon";
import Input from "../components/Input";
import Loading from "../components/Loading";
import Navbar from "../components/Navbar/Navbar";
import { font } from "../components/shared/styles";

const Content = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: row;
  height: 100vh;
  position: fixed;
  left: 0px;
  top: 0px;
  font-family: Open Sans;
`;

const Panel = styled.div`
  height: 100%;
  width: 50vw;
`;

const LeftBar = styled(Panel)``;

const RightBar = styled(Panel)`
  background-color: #f2f2f2;
`;

const InnerContent = styled.div`
  margin-top: 130px;
  padding: 50px;
  height: calc(100% - 130px);
  overflow: auto;
  width: 100%;
`;

const FormTitleText = styled.div`
  color: #535ca5;
  font-size: 20px;
  font-weight: bold;
`;
const GeneratorInput = styled(Input)`
  height: 40px;
  border-radius: 7px;
  font-family: Open Sans;
  font-size: 15px;
`;

const InputAtomTitle = styled.div`
  color: #4c4c4c;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 10px;
`;

const TextAreaAtom = styled.textarea`
  font-family: ${font.body};
  font-style: normal;
  border-radius: 5px;
  padding-left: 20px;
  height: 53px;
  font-size: 20px;
  width: 100%;
  &:focus,
  :active {
    outline: 0;
  }
  height: 160px;
  font-weight: normal;
  font-family: Open Sans;
  font-size: 15px;
  background: #e8e8e8;
  border: 0px;
`;

const PillAtom = styled.div`
  padding: 10px;
  border-radius: 20px;
  background-color: #535ca5;
  color: white;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const GeneratorButton = styled.button`
  background-color: #535ca5;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 40px;
  padding-right: 40px;
  border-radius: 40px;
  color: white;
  font-size: 20px;
  margin-top: 50px;
  margin-horizontal: auto;
`;

const GenerationAtom = styled.div`
  padding: 20px;
  background-color: white;
  border: 1px solid #848dd3;
  border-radius: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const AddTitleAtom = ({ title, children, ...props }) => {
  return (
    <div {...props}>
      <InputAtomTitle>{title}</InputAtomTitle>
      {children}
    </div>
  );
};

const Pill = ({ name, removeState, ...props }) => {
  const remove = () => removeState((s) => s.filter((e) => e !== name));
  return (
    <div style={{ display: "inline-block" }} {...props}>
      <PillAtom>
        <span>{name}</span>
        <Icon
          src={XIcon}
          style={{ marginLeft: 10, cursor: "pointer" }}
          onClick={remove}
        />
      </PillAtom>
    </div>
  );
};

const AddAtom = (props) => {
  return (
    <div
      {...props}
      style={{
        color: "#AAAAAA",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
      }}
    >
      <Icon src={plusGenerator} />
      <div style={{ marginLeft: 10 }}>{props.name}</div>
    </div>
  );
};

const composeIAtom = (InputElem) => ({ type, propObject, ...props }) => {
  return (
    <AddTitleAtom {...props}>
      <InputElem type={type | "text"} {...propObject}></InputElem>
    </AddTitleAtom>
  );
};

const InputAtom = composeIAtom(GeneratorInput);
const TextAreaInput = composeIAtom(TextAreaAtom);

const composeInputAtom = (InputElem) => ({
  type,
  propObject,
  limit,
  ...props
}) => {
  const [length, setLength] = useState(0);
  const [value, setValue] = useState("");

  const changeHandler = propObject.onChange;
  propObject.onChange = (target) => {
    if (!target || !target.target) return;
    const value = target.target.value;
    setLength(value.length);
    if (value.length <= limit - 1) {
      changeHandler(value);
      setValue(value);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <InputElem
        propObject={{ value, ...propObject }}
        type={type}
        {...props}
      ></InputElem>
      <div
        style={{
          position: "absolute",
          right: 10,
          bottom: 3,
          color: "#AAAAAA",
          fontSize: 15,
        }}
      >
        {length}/{limit}
      </div>
    </div>
  );
};

const InputAtomWithLimit = composeInputAtom(InputAtom);
const TextAreaWithLimit = composeInputAtom(TextAreaInput);

// const TextBoxAtom = ({...props})=>{
//     return(
//         <AddTitleAtom {...props}>
//             <TextAreaAtom/>
//         </AddTitleAtom>
//     )
// }

const combineMonad = (...funcs) => (...args) =>
  funcs.forEach((f) => f(...args));

const Generator = () => {
  const [adjectives, setAdjectives] = useState([]);
  const [addingAdjective, setAddingAdjective] = useState(false);
  const [loading, setLoading] = useState(false);

  const [generation, setGeneration] = useState([]);

  const flipSetting = () => setAddingAdjective((s) => !s);

  const transformAndSet = (data) => setGeneration(data);

  const submit = async (s) => {
    setLoading(true);
    const { companyName, audience, description, adHeadline, adDescription } = s;
    const data = await API.getGoogleAd(
      companyName,
      description,
      adjectives,
      audience,
      adHeadline,
      adDescription
    );
    setLoading(false);
    transformAndSet(data);
  };

  return (
    <>
      <Navbar />
      {!loading && (
        <Content>
          <LeftBar>
            <InnerContent>
              <AddSpacing spacing={5}>
                <FormTitleText>Required</FormTitleText>
                <Formik
                  initialValues={[
                    "companyName",
                    "audience",
                    "description",
                    "adHeadline",
                    "adDescription",
                  ].reduce((culm, obj) => {
                    culm[obj] = "";
                    return culm;
                  }, {})}
                  onSubmit={submit}
                >
                  {({ handleChange, handleBlur, handleSubmit }) => {
                    const getPropObject = (
                      name,
                      placeholder = "",
                      type = "text"
                    ) => ({
                      name,
                      type,
                      onChange: handleChange,
                      onBlur: handleBlur,
                      placeholder,
                    });
                    return (
                      <Form>
                        <div className="row">
                          <div className="col-8">
                            <AddSpacing spacing={20}>
                              <InputAtom
                                propObject={getPropObject(
                                  "companyName",
                                  "Add name"
                                )}
                                title="Company Name"
                              />
                              <InputAtom
                                propObject={getPropObject(
                                  "audience",
                                  "Add target audience"
                                )}
                                title="Audience"
                              />
                              <TextAreaInput
                                propObject={getPropObject(
                                  "description",
                                  "Add company description"
                                )}
                                title="Description"
                              />
                            </AddSpacing>
                          </div>
                          <div className="col-4">
                            <AddTitleAtom
                              title="Brand Keywords"
                              style={{ marginTop: 20 }}
                            >
                              <AddSpacing spacing={10}>
                                {adjectives.map((adj, key) => (
                                  <div>
                                    <Pill
                                      name={adj}
                                      key={key}
                                      className="mt-1 mb-1"
                                      removeState={setAdjectives}
                                    />
                                  </div>
                                ))}
                                {addingAdjective && (
                                  <Formik
                                    initialValues={{ adj: "" }}
                                    onSubmit={combineMonad(
                                      ({ adj }) =>
                                        setAdjectives((adjs) => [...adjs, adj]),
                                      flipSetting
                                    )}
                                  >
                                    {({
                                      handleChange,
                                      handleBlur,
                                      handleSubmit,
                                    }) => (
                                      <Form>
                                        <GeneratorInput
                                          name="adj"
                                          type="text"
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          onSubmit={handleSubmit}
                                        />
                                      </Form>
                                    )}
                                  </Formik>
                                )}
                                <AddAtom
                                  name={addingAdjective ? "Cancel" : "Add"}
                                  onClick={flipSetting}
                                />
                              </AddSpacing>
                            </AddTitleAtom>
                          </div>
                        </div>
                        <FormTitleText style={{ marginTop: 20 }}>
                          Optional
                        </FormTitleText>
                        <div style={{ marginTop: 20 }}>
                          Input up to 3 past ads
                        </div>
                        <div style={{ color: "#AAAAAA", fontSize: 15 }}>
                          <i>
                            This helps our AI capture your preferred voice and
                            style
                          </i>
                        </div>
                        <InputAtomWithLimit
                          limit={30}
                          propObject={getPropObject(
                            "adHeadline",
                            "Google Ad Headline"
                          )}
                          title=""
                        />
                        <TextAreaWithLimit
                          propObject={getPropObject(
                            "adDescription",
                            "Google Ad Description"
                          )}
                          title=""
                          limit={90}
                        />
                        <div style={{ width: "100%", textAlign: "center" }}>
                          <GeneratorButton
                            type="submit"
                            onSubmit={handleSubmit}
                          >
                            Generate
                          </GeneratorButton>
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
              </AddSpacing>
            </InnerContent>
          </LeftBar>
          <RightBar>
            <InnerContent>
              {generation.length !== 0 && (
                <AddSpacing spacing={20}>
                  <></>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <InputAtomTitle>My Google Ads</InputAtomTitle>
                    <div>Save</div>
                  </div>
                  {generation.map(([title, text]) => (
                    <GenerationAtom>
                      <div style={{ fontWeight: "bold", fontSize: 20 }}>
                        <bold>{title}</bold>
                      </div>
                      <div>
                        {text.split("\n").map((para, key) => (
                          <p key={key}>{para}</p>
                        ))}
                      </div>
                    </GenerationAtom>
                  ))}
                </AddSpacing>
              )}
            </InnerContent>
          </RightBar>
        </Content>
      )}
      {loading && <Loading />}
    </>
  );
};

export default Generator;
